module.exports = __webpack_public_path__ + "static/img/parking-icon-active.eb55f511.svg";